import React, { useContext, useEffect } from 'react';

import { Button, Grid, theme } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useTheme as useThemeStyledComponents } from 'styled-components';
import { useMenu } from '@/contexts/Menu';
import { useTheme } from '@/contexts/Theme';
import { Container, Title } from './styles';
import AssumingBox from '../AssumingBox';
import AvatarMenu from '../AvatarMenu';
import { topTitleContext } from '../../../contexts/TopTitle';

const { useToken } = theme;

const TopBar: React.FC = () => {
    const { title, titleValue } = useContext(topTitleContext);

    const { theme } = useTheme();

    const { colors } = useThemeStyledComponents();

    const { token } = useToken();

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.xl;

    const { isCollapsed, setCollapsed } = useMenu();

    useEffect(() => {
        if (!title) titleValue(title);
    }, [title]);

    const styles: React.CSSProperties = {
        backgroundColor: theme === 'dark' ? token.colorBgContainer : undefined,
        ...(isMobile && {
            position: 'fixed',
            zIndex: 999,
        }),
        borderBottom: `1px solid ${
            theme === 'dark' ? token.colorBorder : colors.lightGrey
        }`,
    };

    return (
        <Container style={styles}>
            <Button
                type="primary"
                icon={
                    isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                }
                onClick={() => setCollapsed(!isCollapsed)}
                style={{ display: isMobile ? 'none' : 'flex' }}
            />
            <Title style={{ marginLeft: isMobile ? 30 : 15 }}>{title}</Title>
            <AssumingBox />
            <AvatarMenu />
        </Container>
    );
};

export default TopBar;
